/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {UserModel} from '../../../../app/modules/auth/models/UserModel'
import {RootState} from '../../../../setup'
import {Languages} from './Languages'
import * as auth from '../../../../app/modules/auth/redux/AuthRedux'
import {useDispatch} from 'react-redux'
import {toAbsoluteUrl} from '../../../helpers'
import {useAuth0} from '@auth0/auth0-react'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'
import { ChangePasswordModal } from './ChangePasswordModal'
import axios from 'axios'

const HeaderUserMenu: FC = () => {
  let user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false)
  const {logout: auth0Logout} = useAuth0()

  const dispatch = useDispatch()

  const history = useHistory()

  const logout = () => {
    dispatch(auth.actions.logout())
    history.push('/login')
    localStorage.removeItem('isAuthorized')
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.png')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {user?.firstName} {user?.lastName}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {user?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5 my-1'>
        <a className='menu-link px-5' onClick={() => setShowChangePasswordModal(true)} >
          Change Password
        </a>
      </div>
      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>

      <ChangePasswordModal show={showChangePasswordModal} handleClose={() => setShowChangePasswordModal(false) } ></ChangePasswordModal>
    </div>
  )
}

export {HeaderUserMenu}
